import { render, staticRenderFns } from "./aboutRange.vue?vue&type=template&id=08118dbb&scoped=true"
import script from "./aboutRange.vue?vue&type=script&lang=js"
export * from "./aboutRange.vue?vue&type=script&lang=js"
import style0 from "./aboutRange.vue?vue&type=style&index=0&id=08118dbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08118dbb",
  null
  
)

export default component.exports